<template>
  <v-col cols="12">
    <v-col class="col-sm-12 col-xs-12">
      <v-card color="white" dark class="rounded-xl" flat>
        <v-card-title class="text-h5" style="color: #6b6868"> </v-card-title>

        <v-card-subtitle>
          <v-alert
            outlined
            type="error"
            prominent
            border="left"
            style="margin-top: 1em"
            v-if="formErrors.length > 0"
          >
            <b>Veuillez corriger les erreurs suivantes:</b>
            <ul>
              <li v-for="(error, index) in formErrors" :key="index">
                • {{ error }}
              </li>
            </ul>
          </v-alert>
          <section
            style="
              background: rgba(255, 255, 255, 0.9);
              color: #777171;
              padding: 1em;
            "
          >
            <v-form>
              <v-row>
                <v-col cols="12" style="margin-top: -2em">
                  <v-container class="px-0" fluid>
                    <input
                      type="checkbox"
                      v-model="formFields.isCurrentWork"
                      style="font-size: x-large"
                      id="checkbox"
                    />
                    <label for="checkbox" class="" style="font-size: large"
                      >Activité en cours
                    </label>
                  </v-container>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formFields.begin"
                        label="Début de votre activité"
                        light
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formFields.begin"
                      :active-picker.sync="activePicker"
                      :max="calendarMaxDate"
                      :min="calendarMinDate"
                      @change="save"
                      locale="fr-fr"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formFields.end"
                        label="Fin de votre activité"
                        light
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :disabled="formFields.isCurrentWork"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formFields.end"
                      :active-picker.sync="activePicker1"
                      :max="calendarMaxDate"
                      :min="calendarMinDate1"
                      @change="save1"
                      locale="fr-fr"
                      :disabled="formFields.isCurrentWork"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-text-field
                    label="Nom de l'entreprise"
                    v-model="formFields.companyName"
                    placeholder="Ex: Russal Guinée"
                    prepend-inner-icon="mdi-domain"
                    light
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" style="margin-top: -2em">
                  <v-textarea
                    label="Adresse"
                    v-model="formFields.adresse"
                    placeholder="Ratoma, près de l'hôpital"
                    persistent-placeholder
                    prepend-inner-icon="mdi-office-building-marker-outline"
                    light
                    rows="1"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" style="margin-top: -2em">
                  <v-combobox
                    label="Poste occupé"
                    id="job"
                    v-model="formFields.job"
                    item-text="name"
                    item-value="id"
                    :items="jobItems"
                    prepend-inner-icon="mdi-account-search-outline"
                    @blur="checkForNewValue"
                    light
                    required
                    chips
                  ></v-combobox>
                </v-col>

                <v-col cols="12" md="6" style="">
                  <h6>Description de votre activité</h6>
                </v-col>
                <v-col cols="12">
                  <editor
                    api-key="tengbryysq97t0kqjj6qhj25ssgheorm0nv6m0vf8aev6s9z"
                    v-model="formFields.description"
                    :init="{
                      resize: false,
                      height: 200,
                      menubar: true,
                      language: 'fr_FR',
                      plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount',
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic backcolor | \
                                 alignleft aligncenter alignright alignjustify | \
                                 bullist numlist outdent indent | removeformat | help',
                    }"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" sm="12" xs="12">
                  <v-btn class="col-12" color="success" @click="addExperience">
                    <v-icon left>mdi-table-plus</v-icon>
                    Ajouter
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="this.experiences.length > 0">
                <v-col cols="12">
                  <v-card flat light>
                    <v-card-title
                      >Mes expériences professionnelles</v-card-title
                    >
                    <v-card-text>
                      <template>
                        <v-timeline>
                          <v-timeline-item
                            v-for="(experience, index) in this.experiences"
                            :key="index"
                          >
                            <template>
                              <v-card flat light>
                                <v-card-title
                                  >{{ experience.job.name }} à
                                  {{ experience.companyName }}</v-card-title
                                >
                                <v-card-subtitle style="color: grey">
                                  De {{ experience.beginFr }} à
                                  {{ experience.endFr }}
                                </v-card-subtitle>
                                <v-card-text v-html="experience.description">
                                </v-card-text>
                                <v-card-actions>
                                  <v-btn-toggle
                                    dense
                                    background-color="primary"
                                    dark
                                  >
                                    <v-btn
                                      @click="
                                        deleteUserExperience(experience, index)
                                      "
                                      icon
                                      title="Supprimer"
                                    >
                                      <v-icon>mdi-delete-sweep</v-icon>
                                    </v-btn>
                                    <v-btn
                                      v-if="index > 0"
                                      @click="top(experience)"
                                      title="Remonter"
                                      icon
                                    >
                                      <v-icon>mdi-arrow-up-right-bold</v-icon>
                                    </v-btn>
                                    <v-btn
                                      v-if="canBeDowned(index)"
                                      @click="down(experience)"
                                      title="Descendre"
                                      icon
                                    >
                                      <v-icon>mdi-arrow-down-right-bold</v-icon>
                                    </v-btn>
                                  </v-btn-toggle>
                                </v-card-actions>
                              </v-card>
                            </template>
                          </v-timeline-item>
                        </v-timeline>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" sm="12" xs="12">
                  <v-btn
                    class="col-12"
                    color="primary"
                    @click="createUserExperiences"
                  >
                    Enregistrer et continuer
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </section>
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-col>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";
import Editor from "@tinymce/tinymce-vue";

export default Vue.extend({
  name: "CvGeneratorWorkForm",
  components: { Editor },
  props: {
    informationsNextStepCallBack: Function,
  },
  data: function () {
    return {
      currentSeeker: null,
      calendarMinDate: null,
      calendarMinDate1: null,
      calendarMaxDate: null,
      activePicker: null,
      activePicker1: null,
      formFields: {
        begin: null,
        end: null,
        isCurrentWork: false,
        companyName: null,
        adresse: null,
        description: null,
        job: null,
      },
      experiences: [],
      date: null,
      currentUserInfos: {},
      menu: false,
      menu1: false,
      jobItems: [],
      jobList: [],
      formErrors: [],
      lastIndex: -1,
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menu1(val) {
      val && setTimeout(() => (this.activePicker1 = "YEAR"));
    },
  },
  methods: {
    checkForNewValue(newValue) {
      if (!(newValue.target.value == null || newValue.target.value === "")) {
        if (typeof newValue.target.value == "string") {
          console.log("new value", newValue.target.value);
          this.formFields.job = newValue.target.value;
          console.log("this.formfields.job", this.formFields.job)
        }
      }
    },
    arrayMove(arr, oldIndex, newIndex) {
      if (newIndex >= arr.length) {
        var k = newIndex - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
      return arr;
    },

    top(element) {
      let index;
      if ("id" in element) {
        index = this.experiences.findIndex((object) => {
          return object.id === element.id;
        });
      } else {
        index = this.experiences.findIndex((object) => {
          return object.position === element.position;
        });
      }

      this.experiences[index].isPositionEdited = true;
      this.experiences[index - 1].isPositionEdited = true;

      this.experiences = this.arrayMove(this.experiences, index, index - 1);
    },

    down(element) {
      let index;
      if ("id" in element) {
        index = this.experiences.findIndex((object) => {
          return object.id === element.id;
        });
      } else {
        index = this.experiences.findIndex((object) => {
          return object.position === element.position;
        });
      }

      this.experiences[index].isPositionEdited = true;
      this.experiences[index + 1].isPositionEdited = true;

      this.experiences = this.arrayMove(this.experiences, index, index + 1);
    },

    displayDateToFrFormat(date) {
      const splittedDate = date.split("-");
      console.log(splittedDate);
      console.log(`${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`);
      return `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
    },

    canBeDowned(index) {
      if (this.experiences.length - 1 == index) {
        return false;
      }
      return true;
    },

    checkExperienceIsValid() {
      const experience = this.formFields;
      this.formErrors = [];
      let isValid = true;

      if (experience.begin === null) {
        isValid = false;
        this.formErrors.push(
          "La date de début de votre activité est obligatoire."
        );
      }

      if (experience.end === null && !experience.isCurrentWork) {
        isValid = false;
        this.formErrors.push(
          "La date de fin de votre activité est obligatoire."
        );
      }

      if (!experience.companyName || experience.companyName.trim() === "") {
        isValid = false;
        this.formErrors.push("Le nom de l'entreprise est obligatoire.");
      }

      // console.log("Experience.job value : ", this.formFields);
      // console.log("Experience.job value : ", this.formFields.job);
      // console.log("Experience.job value : ", this.formFields['job']);
      console.log(this.realJob);
      console.log(this.formFields);
      console.log(this.formFields.end);
      console.log(this.formFields.begin);
      console.log(this.formFields.adresse);
      console.log(this.formFields.companyName);
      console.log(this.formFields.description);
      console.log(this.formFields.job);
      if (this.formFields.job == null || this.formFields.job === "") {
        console.log(experience);
        isValid = false;
        this.formErrors.push("Le poste occupé est obligatoire.");
      }

      return isValid;
    },
    addExperience(event) {
      // this.addExperience();
      if (this.checkExperienceIsValid()) {
        // add experience to local store
        let experience = this.formFields;
        let tmp = this.lastIndex + 1;
        experience["_index"] = tmp;
        experience.position = this.experiences.length;
        experience.isPositionEdited = false;
        if (typeof experience.job == "string") {
            experience.job = {
              name: experience.job,
            };
        }

        experience = {
          ...experience,
          beginFr: this.displayDateToFrFormat(experience.begin),
          endFr: experience.isCurrentWork
            ? "Aujourd' hui"
            : this.displayDateToFrFormat(experience.end),
        };
        this.experiences.push(experience);

        this.lastIndex = tmp;

        this.formFields = {
          begin: null,
          end: null,
          isCurrentWork: false,
          companyName: null,
          adresse: null,
          description: null,
          job: null,
        };
      }
      return false;
    },
    save(date) {
      this.$refs.menu.save(date);

      const formattedDate = date.split("-");
      this.calendarMinDate1 = `${parseInt(formattedDate[0], 10)}-${(
        "0" + parseInt(formattedDate[1], 10)
      ).slice(-2)}-${("0" + parseInt(formattedDate[2], 10)).slice(-2)}`;
    },
    save1(date) {
      this.$refs.menu1.save(date);
    },
    createUserExperiences: async function () {
      this.experiences.map((el, index) => (el.position = index));
      if (this.experiences.length > 0) {
        console.log(this.experiences);
        for (const el of this.experiences) {
          if (!Object.prototype.hasOwnProperty.call(el, "id")) {
            await this.createUserExperience(el);
          } else if (el.isPositionEdited) {
            await this.updateUserExperience(el);
          }
        }
        this.informationsNextStepCallBack(4);
      }
      this.informationsNextStepCallBack(4);
    },

    createUserExperience: async function (el) {
      console.log("creating el");
      const httpClient = new HttpClient();
      let position;
      if ("position" in el) {
        position = el.position;
      } else {
        let index;

        if ("id" in el) {
          index = this.experiences.findIndex((object) => {
            return object.id === el.id;
          });
        } else {
          index = this.experiences.findIndex((object) => {
            return object.position === el.position;
          });
        }
        position = index;
      }

      console.log(position);
      console.log(this.currentSeeker.id);
      await httpClient
        .createExperienceDetails(
          {
            isCurrentJob: el.isCurrentWork,
            startDate: new Date(el.begin),
            endDate: new Date(el.end),
            companyName: el.companyName,
            companyLocation: el.adresse,
            job: el.job.id,
            description: el.description,
            isDeleted: false,
            seeker: `/api/seekers/${this.currentSeeker.id}`,
            deletedAt: null,
            name: el.job.name,
            position: position,
          },
          localStorage.getItem("jwt-token")
        )
        .then(async (value) => {
          let tmpSeeker = {
            id: this.currentSeeker.id,
            isPersonalInformationsFilled: true,
            isProfessionalExperiencesFilled: true,
          };

          await httpClient
            .updateSeekerInformations(
              tmpSeeker,
              localStorage.getItem("jwt-token")
            )
            .then((res) => {
              this.currentSeeker = res.data;
              this.informationsNextStepCallBack(4);
            })
            .catch((reason) => {
              if (reason.response.status === 401) {
                this.$router.push("/logout");
              }

              alert("Une erreur s'est produite");
              console.error(reason);
            });
          this.load();
        })
        .catch((reason) => {
          if (reason.response.status === 401) {
            this.$router.push("/logout");
          }
          this.formErrors = [];
          this.formErrors.push("Une erreur s'est produite");
        });
    },

    updateUserExperience: async function (el) {
      const httpClient = new HttpClient();
      await httpClient
        .updateExperienceDetails(
          el.id,
          {
            position: el.position,
          },
          localStorage.getItem("jwt-token")
        )
        .then(async (value) => {
          this.load();
        })
        .catch((reason) => {
          if (reason.response.status === 401) {
            this.$router.push("/logout");
          }
          this.formErrors = [];
          this.formErrors.push("Une erreur s'est produite");
        });
    },

    deleteUserExperience: async function (el, index) {
      const httpClient = new HttpClient();
      if ("id" in el) {
        await httpClient
          .deleteExperienceDetails(
            {
              id: el.id,
            },
            localStorage.getItem("jwt-token")
          )
          .then(async (value) => {
            this.experiences.splice(index, 1);
            console.log("value", value);
          })
          .catch((reason) => {
            if (reason.response.status === 401) {
              this.$router.push("/logout");
            }
            this.formErrors = [];
            this.formErrors.push("Une erreur s'est produite");
          });
      } else {
        this.experiences.splice(index, 1);
      }
    },

    load: async function () {
      const httpClient = new HttpClient();
      httpClient
        .getExperienceDetailsByUser(localStorage.getItem("jwt-token"))
        .then((value) => {
          this.experienceList = value.data;
          this.experiences = this.experienceList.map((el) => ({
            id: el.id,
            begin: el.startDate,
            beginFr: new Date(el.startDate).toLocaleDateString("fr-FR"),
            endFr: el.isCurrentJob
              ? "Aujourd' hui"
              : new Date(el.endDate).toLocaleDateString("fr-FR"),
            end: el.endDate,
            isCurrentWork: el.isCurrentJob,
            companyName: el.companyName,
            adresse: el.companyLocation,
            description: el.description,
            position: el.position,
            job: { id: el.job, name: el.name },
          }));
        })
        .catch((reason) => {
          if (reason.response.status === 401) {
            this.$router.push("/logout");
          }
          this.formErrors.push(reason);
          console.error(reason);
        });
    },
  },
  created() {
    const httpClient = new HttpClient();
    httpClient
      .getCurrentUserInformations(localStorage.getItem("jwt-token"))
      .then((value) => {
        // fetch current seeker
        httpClient
          .getCurrentSeeker(localStorage.getItem("jwt-token"))
          .then((res) => {
            this.currentSeeker = res.data;
            console.log(this.currentSeeker);
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status === 401) {
              this.$router.push("/logout");
            }
          });

        this.currentUserInfos = value.data;
        if (this.currentUserInfos.birthday) {
          const _date = this.currentUserInfos.birthday.split("T")[0];
          const currentUserBirthday = _date.split("-");

          const currentDate = new Date();
          this.calendarMaxDate = `${currentDate.getFullYear()}-${(
            "0" +
            (currentDate.getMonth() + 1)
          ).slice(-2)}-${("0" + currentDate.getDate()).slice(-2)}`;
          this.calendarMinDate = `${
            parseInt(currentUserBirthday[0], 10) + 8
          }-${("0" + parseInt(currentUserBirthday[1], 10)).slice(-2)}-${(
            "0" + parseInt(currentUserBirthday[2], 10)
          ).slice(-2)}`;
          this.calendarMinDate1 = `${
            parseInt(currentUserBirthday[0], 10) + 8
          }-${("0" + parseInt(currentUserBirthday[1], 10)).slice(-2)}-${(
            "0" + parseInt(currentUserBirthday[2], 10)
          ).slice(-2)}`;
        } else {
          const currentDate = new Date();
          this.calendarMaxDate = `${currentDate.getFullYear()}-${(
            "0" +
            (currentDate.getMonth() + 1)
          ).slice(-2)}-${("0" + currentDate.getDate()).slice(-2)}`;
          this.calendarMinDate = "1970-01-01";
          this.calendarMinDate1 = "1970-01-01";
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 401) {
          this.$router.push("/logout");
        }
      });

    // load job
    httpClient
      .getJobs(localStorage.getItem("jwt-token"))
      .then((value) => {
        this.jobList = value.data["hydra:member"];
        this.jobList.forEach((elt) => {
          this.jobItems.push({
            id: elt["@id"],
            name: elt["name"],
          });
        });
      })
      .catch((reason) => {
        if (reason.response.status === 401) {
          this.$router.push("/logout");
        }
        this.formErrors.push(reason);
        console.error(reason);
      });

    // load experiences

    this.load();
  },
});
</script>

<style scoped></style>
